import MagicEditor from "components/layout/MagicEditor";
import { ContextMenuContext } from "contexts/ContextMenuContext";
import { PriorityModalContext } from "contexts/PriorityModalContext";
import { useContext, useEffect, useRef, useState } from "react";
import { HiOutlinePencil } from "react-icons/hi2";
import { TbPencil } from "react-icons/tb";
// import { useOnClickOutside } from "usehooks-ts";
// import useOnClickOutside from "utils/hooks/useOnClickOutside";
import useOnClickOutsideMultiple from "utils/hooks/useOnClickOutsideMultiple";

const formatInitialValue = (string) => {
    string = string || "";
    return string.replace(/(<style[\w\W]+style>)/g, "")
}

const TextPreview = ({
    text,
    network,
    isEditable = false,
    onTextEdit = undefined,
    post = undefined,
    previewClassName = "",
    editClassName = "",
    magicEditorClassName = "",
    magicEditorFooterClassName = "",
    optionsBarClassName = "",
    isTitle = false
}) => {

    const [ isEditing, setIsEditing ] = useState(false);
    const [ value, setValue ] = useState(formatInitialValue(text));
    const [ valueOnEdit, setValueOnEdit ] = useState(formatInitialValue(text));
    const { isOpenedPriority } = useContext(PriorityModalContext);
    const { contextMenuRef } = useContext(ContextMenuContext);
    const wrapperRef = useRef();

    const onCancel = () => {
        setValue(valueOnEdit);
        setIsEditing(false);
    }

    const onConfirm = () => {
        onTextEdit && onTextEdit(value);
        setIsEditing(false);
    }

    useOnClickOutsideMultiple([wrapperRef, contextMenuRef], () => {
        if (!isOpenedPriority && !!wrapperRef.current) {
            onTextEdit && onTextEdit(value);
            setIsEditing(false);
        }
    }, [value, isOpenedPriority]);

    useEffect(() => {
        if (isEditing == true) {
            setValueOnEdit(value);
        }
    }, [isEditing]);

    useEffect(() => {
        if (text != value) {
            setValue(text);
        }
    }, [text]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && (e.metaKey || e.shiftKey)) {
            e.preventDefault();
            onConfirm();
        }
    };

    return (
        <div className="!text-base">
            {!isEditing 
                ? <div className={`${isEditable && `group cursor-pointer isEditable`} ${(!value || !value?.trim()) && `mb-2`} inline-block w-full ${network != "medium" && `whitespace-pre-wrap`}`} onClick={() => isEditable && setIsEditing(true)}>
                    <span className={`text-gray-700 dark:!text-gray-200 group-hover:!bg-tertiary-100 dark:group-hover:!bg-gray-900 bg-hover-children break-words ${(!value || !value?.trim()) && `w-[90%] inline-block !text-tertiary-400 dark:text-gray-600 italic`} ${previewClassName}`} dangerouslySetInnerHTML={{__html: value?.trim() || value || (isEditable ? "Click here to add text to this post..." : ``)}}></span>
                    <span><TbPencil className="text-tertiary-400 ml-0.5 hidden group-hover:inline -translate-y-0.5" /></span>
                </div>
                : <div className={`relative ${editClassName}`} ref={wrapperRef}>
                    <MagicEditor 
                        value={value}
                        setValue={setValue}
                        network={network}
                        mediaProductType={post?.preferences?.media_product_type}
                        className={`!text-tertiary-500 dark:text-gray-400 dark:!text-gray-50 !p-0 w-full !overflow-y-hidden bg-secondary-500 dark:bg-gray-800 ${magicEditorClassName}`}
                        footerClassName={`!border-0 !px-0 !mt-4 !rounded-xl !rounded-t-xl !rounded-b-xl ${magicEditorFooterClassName}`}
                        optionsBarClassName={optionsBarClassName}
                        onCancel={onCancel}
                        onConfirm={onConfirm}
                        minHeight={10}
                        autoFocus={true}
                        post={post}
                        isTitle={isTitle}
                        onKeyDown={handleKeyDown}
                    />
                </div>
            }
        </div>
    );
}

export default TextPreview;